<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入兑换码" v-model="searchVal" @change="getData" style="width:240px;margin-right:15px" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-input placeholder="输入批次" v-model="searchBatch" @change="getData" style="width:240px;margin-right:15px" clearable></el-input>
            <el-button type="success" plain @click="handleShow()" icon="el-icon-plus">添加</el-button >
            <!-- <el-button type="success" plain @click="handleShow()" icon="el-icon-edit">批量修改</el-button > -->
            <el-button type="danger" plain @click="handleAllDel()" icon="el-icon-delete">批量删除</el-button >
        </div>
        <el-card >
            <el-table :data="tableData"  height="580" @selection-change="handleSelect">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="batch" label="活动批次" align="center"></el-table-column>
                <el-table-column prop="code" label="兑换码" align="center"></el-table-column>
                <el-table-column prop="code" label="奖品类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 0" style="color:red;">优惠券</span>
                        <span v-if="scope.row.type == 1" style="color:green">礼品</span>
                        <span v-if="scope.row.type == 2" style="color:orange">优惠返利</span>
                    </template>
                </el-table-column>
                <el-table-column prop="batch" label="奖品信息" align="center" show-overflow-tooltip="">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 0" style="color:red;">
                            <div>
                                <m-img v-if="scope.row.coupon.pic" :src="scope.row.coupon.pic.url" :width="351" :height="114" />
                            </div>
                            <span v-if="scope.row.coupon.discount==1">C${{scope.row.coupon.coupon_money}}</span>
                            <span v-if="scope.row.coupon.discount==2">满C${{scope.row.coupon.full_money}}减C${{scope.row.coupon.reduce}}</span>
                            <span v-if="scope.row.coupon.discount==3">{{scope.row.coupon.coupon_money}}%</span>
                        </div>
                        <div v-if="scope.row.type == 1" style="color:green">
                            <div>
                                <m-img v-if="scope.row.gift.pic" :src="scope.row.gift.pic" :width="120" :height="120" />
                            </div>
                            {{scope.row.gift.title}}
                        </div>
                        <div v-if="scope.row.type == 2" style="color:orange">返利比例：{{scope.row.rebate.rebate_scale}}%</div>
                    </template>
                </el-table-column>
                <el-table-column prop="batch" label="领取状态" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.use_status == 0" >
                            未领取
                        </el-link>
                        <el-link  type="success"  v-if="scope.row.use_status == 1">
                            已领取
                        </el-link>
                        <el-link type="danger" v-if="scope.row.use_status == -1" >
                            已过期
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="receive_time" label="领取时间" align="center" width="160"></el-table-column>
                <el-table-column prop="expire_time" label="过期时间" align="center" width="160"></el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="changeStatus(scope.row)"
                            >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center" width="285">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini"  @click="handleDetail(scope.row)" v-if="scope.row.use_status == 1">领取查看</el-button>
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)">删除</el-button> 
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="dialog" :title="dialogTitle"  width="800px" align="center">
            <el-row class="line-item">
                <el-col :span="4" class="item-label">活动批次：</el-col>
                <el-col :span="20">
                    <el-input placeholder="请输入批次" v-model="batch" style="width: 240px"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="item-label">兑换码：</el-col>
                <el-col :span="20" class="code-input">
                    <el-input oninput="value=value.replace(/[^\w\.\/]/ig,'').toUpperCase()" @blur="code = $event.target.value" placeholder="请输入兑换码" v-model="code" style="width: 240px;"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item" v-if="id == ''">
                <el-col :span="4" class="item-label">范围(非必填)：</el-col>
                <el-col :span="20" class="range">
                    <el-input placeholder="请输入最小" oninput="value=value.replace(/[^\d]/g,'')" @blur="range1 = $event.target.value" v-model="range1" style="width: 120px"></el-input>
                    <span>-</span>
                    <el-input placeholder="请输入最大" oninput="value=value.replace(/[^\d]/g,'')" @blur="range2 = $event.target.value" v-model="range2" style="width: 120px"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="item-label">奖品类型：</el-col>
                <el-col :span="20" class="item-label">
                    <el-radio-group v-model="type" @change="changeType">
                        <el-radio :label="0" border>优惠券</el-radio>
                        <el-radio :label="1" border>礼品</el-radio>
                        <el-radio :label="2" border>优惠返利</el-radio>
                    </el-radio-group>
                </el-col>
            </el-row>
            <div v-if="type == 0" style="margin-top:25px">
                <el-row class="line-item">
                    <el-col :span="4" class="item-label">优惠券：</el-col>
                    <el-col :span="20" class="item-label">
                        <el-select v-model="type_item" placeholder="请选择">
                            <el-option
                            v-for="item in couponList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <div v-else-if="type == 1" style="margin-top:25px">
                <el-row class="line-item">
                    <el-col :span="4" class="item-label">礼品：</el-col>
                    <el-col :span="20" class="item-label">
                        <el-select v-model="type_item" placeholder="请选择">
                            <el-option
                            v-for="item in giftList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <div v-else style="margin-top:25px">
                <el-row class="line-item">
                    <el-col :span="4" class="item-label">优惠返利：</el-col>
                    <el-col :span="20" class="item-label">
                        <el-select v-model="type_item" placeholder="请选择">
                            <el-option
                            v-for="item in rebateList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <el-row class="line-item">
                <el-col :span="4" class="item-label">过期时间：</el-col>
                <el-col :span="20">
                    <el-date-picker v-model="expire_time" value-format="timestamp"  type="datetime" placeholder="选择兑换码过期时间" style="width:40%"></el-date-picker>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="item-label">状态：</el-col>
                <el-col :span="20" class="item-label">
                    <el-radio v-model="status" :label="1" border>启用</el-radio>
                    <el-radio v-model="status" :label="0" border>禁用</el-radio>
                </el-col>
            </el-row>
            <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="dialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="detailDialog" title="领取详情"  width="800px" align="center">
        <el-row class="line-item">
                <el-col :span="4" class="item-label">用户账号：</el-col>
                <el-col :span="20">
                    <el-input placeholder="请输入批次" v-model="detail.user.username" style="width: 240px" readonly></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item" v-if="detail.user.phone">
                <el-col :span="4" class="item-label">用户手机号：</el-col>
                <el-col :span="20">
                    <el-input placeholder="请输入批次" v-model="detail.user.phone" style="width: 240px" readonly></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item" v-if="detail.user.email">
                <el-col :span="4" class="item-label">用户邮箱：</el-col>
                <el-col :span="20">
                    <el-input placeholder="请输入批次" v-model="detail.user.email" style="width: 240px" readonly></el-input>
                </el-col>
            </el-row>
            <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="detailDialog = false" style="width:120px">关闭</el-button></el-col>
            </el-row>
        </el-dialog>
    </section>
</template>
<script>
import {  swap_list, swap_add, swap_put, swap_del, coupon_list, rebate_list, gift_list  } from '@/api/market.js'
import { parseTime } from '@/untils/index.js'
import MImg   from '@/components/Image'
export default {
    components: { MImg },
    data() {
        return {
            searchVal: '',
            searchBatch: '', // 批次
            tableData: [],
            table_load: false,
            total: 0,
            page: 1,
            size: 0,
            dialog: false,    // 控制显示 添加修改弹窗
            dialogTitle: '',
            id:'',           //  有id 是修改  没有id是添加
            batch: '',
            code:'',
            range1:'',
            range2:'',
            expire_time: '',
            type: 0,
            type_item: '',
            status: 1,
            couponList: [], // 优惠券列表
            giftList: [], // 礼品列表
            rebateList: '', // 返利列表
            disabled: false,
            ids: [],
            detailDialog: false,
            detail: {
                user:''
            }
        }
    },
    methods: {
        getData() {
            let params = {
                page:this.page,
                is_page: 1
            }
            if(this.searchVal != '') {
                params.keywords = this.searchVal
            }
            if(this.searchBatch != '') {
                params.batch = this.searchBatch
            }
            swap_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                    this.size = 0
                }
            })
        },
        reloadData(page) {
            this.page = page;
            this.getData();
        },
        changeType() {
            this.type_item = ''
        },
        // 获取优惠券列表
        getCoupon() {
            coupon_list({is_page: 0}).then(res => {
                if(res) {
                    this.couponList = res.data
                    this.couponList.forEach(item => {
                        if(item.discount == 1) {
                            item.title = 'C$' + item.coupon_money
                        } else if (item.discount == 2) {
                            item.title = '满C$' + item.full_money + '减C$' + item.reduce
                        } else {
                            item.title = item.coupon_money + '%'
                        }
                    })
                }
            })
        },
        // 获取优惠返利列表
        getRebate() {
            rebate_list().then(res => {
                if(res) {
                    this.rebateList = res.data
                }
            })
        },
        // 获取礼品列表
        getGift() {
            gift_list().then(res => {
                if(res) {
                    this.giftList = res.data
                }
            })
        },
        // 多选
        handleSelect(e) {
            e.forEach(item => {
                this.ids.push(item.id)
            })
        },
        resetData() {
            this.id = ''
            this.code = ''
            this.status = 1
            this.type = 0
            this.type_item = ''
            this.expire_time = ''
            this.range1 = ''
            this.range2 = ''
            this.batch = ''
        },
        handleDetail(row) {
            this.detail = row
            this.detailDialog = true
        },
        // 显示 添加 || 修改 弹窗
        handleShow(row) {
            this.dialog = true
            if(row) {
                this.dialogTitle = '修改兑换码'
                this.id = row.id
                this.code = row.code
                this.status = row.status
                this.type = row.type
                this.type_item = row.type_item
                this.batch = row.batch
                this.expire_time = new Date(row.expire_time)
            } else {
                this.dialogTitle = '添加兑换码'
                this.resetData()
            }
        },
        // 弹窗里面 点击确定
        handleBtn() {
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.batch == '') {
                return this.$message({type:'warning', message: '请输入批次'})
            }
            console.log(this.code)
            if(this.code == '') {
                return this.$message({type:'warning', message: '请输入兑换码'})
            }
            if(this.type_item == '') {
                if(this.type == 0) {
                    this.$message({type:'warning', message: '请选择优惠券'})
                } else if( this.type == 1){
                    this.$message({type:'warning', message: '请选择礼品'})
                } else {
                    this.$message({type:'warning', message: '请选择优惠返利'})
                }
                return false
            }
            if(this.expire_time == '') {
                return this.$message({type:'warning', message: '请选择过期时间'})
            }
            let range = [this.range1,this.range2]
            let params = {
                batch: this.batch,
                code: this.code,
                status: this.status,
                type: this.type,
                expire_time: parseTime(this.expire_time/1000),
                type_item: this.type_item,
            }
            if(this.range1 != '' && this.range2 != '') {
                params.range = range
            }
            this.disabled = true
            if(this.id == ""){
                swap_add(params).then(res => {
                    if(res) {
                        this.$message({message:res.msg,type:'success'})
                        this.getData()
                        this.resetData()
                        this.dialog   = false
                    }
                }).finally( () => {
                    this.disabled = false
                })
            } else {
                swap_put(this.id, params).then(res => {
                    if(res) {
                        this.$message({message:res.msg,type:'success'})
                        this.getData()
                        this.resetData()
                        this.dialog   = false
                    }
                }).finally( () => {
                    this.disabled = false
                })
            }
        },
        changeStatus(row) {
            swap_put(row.id, {status:row.status}).then(res => {
                    if(res) {
                        this.$message({message:res.msg,type:'success'})
                    }
                }).finally( () => {
                    this.disabled = false
                })
        },
        // 批量删除
        handleAllDel() {
            if(this.ids.length == 0) {
                return this.$message({type:'warning',message:'请选择兑换码'})
            }
            this.$confirm(`此操作将批量删除选中的兑换码，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                swap_del(this.ids.join(',')).then(res => {
                    if(res) {
                        this.$message({type:"success",message:res.msg})
                        this.getData();
                    }
                })
            }).catch(()=>{});
        },
        // 删除 
        handleDel(row) {
            this.$confirm(`此操作将删除兑换码："${row.code}"，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                swap_del(row.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.getData();
                })
            }).catch(()=>{});
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
        this.getCoupon()
        this.getRebate()
        this.getGift()
    },
}
</script>

<style lang="less" scoped>
section {
    .top-btn {
        width: 100px;
    }
    .item-label {
        height: 40px;
        line-height: 40px;
    }
    .line-item {
        margin-top: 25px;
        &:nth-child(1){
            margin-top: 0;
        }
    }
    /deep/ .el-dialog__body {
        text-align: left
    }
    .range {
        display: flex;
        align-items: center;
        span {
            margin:0 10px;
        }
    }
}
</style>
